import {
  Edit,
  SimpleForm,
  TextInput,
  useRecordContext,
} from 'react-admin';
import { Typography, Box } from '@mui/material';

const ChatTitle = () => {
  const record = useRecordContext();
  return record ? <span>Edit Chat: {record.title}</span> : null;
};

export const ChatEdit = () => {
  return (
    <Edit title={<ChatTitle />}>
      <SimpleForm>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            You can update the chat title and username. These are cosmetic changes
            for admin reference only - they don't affect the actual Telegram chat.
          </Typography>
        </Box>
        <TextInput source="chat_id" disabled label="Chat ID" />
        <TextInput source="title" required label="Chat Title" fullWidth />
        <TextInput source="username" label="Username (without @)" helperText="Optional" />
        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Note: xRocket API key cannot be changed via admin panel for security reasons.
            Owners must update it via the bot.
          </Typography>
        </Box>
      </SimpleForm>
    </Edit>
  );
};
